import { render, staticRenderFns } from "./NucleoIconsSection.vue?vue&type=template&id=5ce829c5"
import script from "./NucleoIconsSection.vue?vue&type=script&lang=js"
export * from "./NucleoIconsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports